import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/e-signature-requests/{eSignatureRequestId}/permissions']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getESignatureRequestPermissions = async ({ eSignatureRequestId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/e-signature-requests/${eSignatureRequestId}/permissions`);
  return response.data;
};

export default getESignatureRequestPermissions;
